




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EnergyLabel extends Vue {
    @Prop()
    protected imageurl!: string;
    @Prop()
    protected energylabelhtml!: string;
    @Prop()
    protected downloadimage!: string;

    protected open: boolean = false;

    constructor() {
        super();
    }

    private toggle() {
        this.open = !this.open;
    }
}
